import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal, SBHorizontal } from '@sorare/core/src/atoms/layout/flex';

import { ItemOwnerSince } from '#src/components/ItemPreview/ItemOwnerSince/index.tsx';
import { InlineCard } from '#src/components/card/InlineCard/index.tsx';

import type { OwnedCardRow_anyCard } from './__generated__/index.graphql.ts';

const CardItem = styled(Horizontal)`
  justify-content: space-between;
  min-height: 40px;
`;

const MaxWidth = styled.div`
  max-width: 100px;
`;

type Props = {
  anyCard: Nullable<OwnedCardRow_anyCard>;
};
export const OwnedCardRow = ({ anyCard }: Props) => {
  if (!anyCard) return null;
  return (
    <CardItem>
      <SBHorizontal>
        <InlineCard anyCard={anyCard} />
        <MaxWidth>
          <ItemOwnerSince card={anyCard} wrap />
        </MaxWidth>
      </SBHorizontal>
    </CardItem>
  );
};

OwnedCardRow.fragments = {
  anyCard: gql`
    fragment OwnedCardRow_anyCard on AnyCardInterface {
      slug
      ...InlineCard_anyCardInterface
      ...ItemOwnerSince_anyCard
    }
    ${InlineCard.fragments.anyCard}
    ${ItemOwnerSince.fragments.anyCard}
  ` as TypedDocumentNode<OwnedCardRow_anyCard>,
};
